import ResetPassword from './ChangePassword';

export default ResetPassword;
